import * as back from '~/components/layouts/Navigation/BreadcrumbContainer/functional/backLinks';
import * as match from '~/components/layouts/Navigation/BreadcrumbContainer/functional/matchers';
import type { BreadcrumbItem, RouteRule } from '~/components/layouts/Navigation/BreadcrumbContainer/functional/types';

export const listingRules: RouteRule[] = [
  {
    match: match.and(match.startsWith('/listing'), match.endsWith('/edit-listing')),
    generate: (context) => {
      const property = context.currentProperty();
      const portfolioId = property?.portfolio?.id;
      const unitListing = context.unitListingDetail();

      const breadcrumbs: BreadcrumbItem[] = [{ label: context.t('Listing'), link: `/listings/${portfolioId}` }];

      if (!context.isMobile) {
        breadcrumbs.push({
          label: unitListing ? `${unitListing?.property?.displayName} - ${unitListing?.unit?.name}` : context.t('Listing details'),
          link: `/listings/${portfolioId}/details/${unitListing?.id}`,
        });
      }

      breadcrumbs.push({ label: context.t('Edit listing') });
      return breadcrumbs;
    },
    backLink: back.goBack,
    priority: 680,
  },
  {
    match: match.and(match.startsWith('/listing'), match.includes('/details/')),
    generate: (context) => {
      const property = context.currentProperty();
      const portfolioId = property?.portfolio?.id;
      const unitListing = context.unitListingDetail();

      return [
        { label: context.t('Listing'), link: `/listings/${portfolioId}` },
        {
          label: unitListing ? `${unitListing?.property?.displayName} - ${unitListing?.unit?.name}` : context.t('Listing details'),
        },
      ];
    },
    backLink: back.goBack,
    priority: 670,
  },
  {
    match: match.startsWith('/listing'),
    generate: (context) => {
      const property = context.currentProperty();
      const portfolioId = property?.portfolio?.id;
      return [{ label: context.t('Listing'), link: `/listings/${portfolioId}` }];
    },
    backLink: back.homeLink,
    priority: 600,
  },
];
